/**
 * Score how well a guest name matches a registered user's name (higher = better).
 */
export function scoreGuestNameMatch(userFirst, userLast, guestFirst, guestLast) {
  const uf = (userFirst || '').trim().toLowerCase();
  const ul = (userLast || '').trim().toLowerCase();
  const gf = (guestFirst || '').trim().toLowerCase();
  const gl = (guestLast || '').trim().toLowerCase();

  if (!uf && !ul) return 0;

  let score = 0;

  if (uf && gf) {
    if (uf === gf) score += 3;
    else if (gf.includes(uf) || uf.includes(gf)) score += 1;
  }

  if (ul && gl) {
    if (ul === gl) score += 3;
    else if (gl.includes(ul) || ul.includes(gl)) score += 1;
  }

  return score;
}

export function partitionGuestsByNameMatch(guests, userFirst, userLast, minScore = 2) {
  const scored = (guests || []).map((guest) => ({
    guest,
    score: scoreGuestNameMatch(userFirst, userLast, guest.first_name, guest.last_name),
  }));

  const suggested = scored
    .filter(({ score }) => score >= minScore)
    .sort((a, b) => b.score - a.score)
    .map(({ guest }) => guest);

  const suggestedIds = new Set(suggested.map((g) => g.id));
  const others = (guests || []).filter((g) => !suggestedIds.has(g.id));

  return { suggested, others };
}
